module.exports = __webpack_public_path__ + "img/桌面式发卡器.ad9d4178.jpg";